import { IdentificationSearchFilterValue } from '../../../components/IdentificationSearchFilter/types';
export enum PaymentHubDebtStatus {
  Pending = 'pending',
  InProcess = 'in_process',
  Payed = 'payed',
}

export interface PaymentHubDebtAmount {
  value: number;
  currency: string;
}

export interface PaymentHubDebt<T = unknown> {
  id: unknown;
  idToDisplay?: unknown;
  type: string;
  details: string;
  installment: number;
  installmentDueDate: Date | null;
  amount: PaymentHubDebtAmount; // Amount without interests
  interests: PaymentHubDebtAmount;
  finalAmount: PaymentHubDebtAmount; // Amount with interests
  status: PaymentHubDebtStatus;
  raw: T; // Data without format
}

export type DebtsFormDataResponse = {
  identificationTypes: Array<{
    id: string;
    name: string;
    countryId: string | null;
  }>;
};

export type DebtsDataParams = Partial<IdentificationSearchFilterValue>;

export type DebtsDataFields = {
  identification?: Partial<IdentificationSearchFilterValue>;
};

export interface RegisterPaymentParams
  extends Partial<IdentificationSearchFilterValue> {
  debtId: unknown;
  paymentType: string;
  documentType: string;
  authorizationCode: string;
  last4CardDigits?: string | null;
  email?: string | null;
}
